// eslint-disable-next-line no-unused-vars
import React, {useState} from 'react';
import styled from 'styled-components';
import PageContentComponent from '../components/ui/pageContentComponent';
import PageContainerTitleComponent from '../components/ui/container/pageContainerTitleComponent';
import CouponRedeem from '../components/ui/reward/couponRedeem';
import LuckyWheel from '../components/ui/reward/luckyWheel';
import {useTranslation} from 'react-i18next';
import {useAuth} from '../hooks/useAuth';
import {Navigate} from 'react-router-dom';

const RewardContainer = styled.div`
  max-width: 600px;
  margin: auto;
  padding: 50px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
`;

const ContentContainer = styled.div`
  margin-top: 20px;
  text-align: center;
  display: flex;
  justify-content: center;
`;

const SectionButton = styled.button`
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  color: ${({active}) => (active ? '#000' : '#fff')};
  cursor: pointer;
  transition: background-color 0.3s ease;
`;

const RewardPage = () => {
  const {t} = useTranslation();
  const [selectedOption, setSelectedOption] = useState('couponcode');
  const {user} = useAuth();

  const sections = {
    couponcode: t('reward.sections.couponcode'),
    luckywheel: t('reward.sections.luckywheel'),
  };

  if (!user) {
    return <Navigate to="/" replace />;
  }

  let content;
  switch (selectedOption) {
    case 'couponcode':
      content = <CouponRedeem />;
      break;
    case 'luckywheel':
      content = <LuckyWheel />;
      break;
    default:
      content = <p>Please select a section.</p>;
  }

  return (
    <PageContentComponent>
      <PageContainerTitleComponent title={t('reward.title')} />
      <ButtonContainer>
        {Object.entries(sections).map(([key, label]) => (
          <SectionButton key={key} onClick={() => setSelectedOption(key)} active={selectedOption === key}>
            {label}
          </SectionButton>
        ))}
      </ButtonContainer>
      <RewardContainer>
        <ContentContainer>{content}</ContentContainer>
      </RewardContainer>
    </PageContentComponent>
  );
};

export default RewardPage;
